import { gql } from '@apollo/client';
import { IncidentFieldsFragment } from './fragments';

export default gql`
  query CalendarIncidents(
    $typeIds: [ID]
    $start: LocalDate
    $end: LocalDate
    $keyword: String
  ) {
    incidents(typeIds: $typeIds, start: $start, end: $end, keyword: $keyword) {
      ...IncidentFields
    }
  }
  ${IncidentFieldsFragment}
`;
